<template >
    <div class="container">
      <div class="">
        <div class="">
             <div class="mt-4 mb-4" v-for="(topic, index) in topics" v-bind:key="topic.id" v-if="topics!=null && topics.length>0">
        <div class="row">
          <div class="col">
            <h5 class="m-0 font-weight-bold text-primary"> Сэдэв {{++index}}: {{topic.name}}<span v-if="topic.shortname" style="font-weight:bold">Товч нэр: {{topic.shortname}}</span></h5>
          </div>
   
           <div class="col col-md-auto col-sm-12">
            <!-- <button class="btn btn-sm btn-secondary mr-2" @click='$router.push({ name: "TopicCreateExam", params: {lessonId: lessonId, topicId:topic.id} })' >Сорил үүсгэх</button> -->
            <button class="btn btn-mygray btn-sm" data-toggle="tooltip" data-html="true" title="Xичээлдээ видео, даалгавар, тест, шалгалт нэмэx" @click="openSaveContentModal(topic)">Агуулга нэмэх</button>
          </div>
        
        </div>
        <hr style="margin-top: 0.4rem; margin-bottom: 0rem; border: 0; border-top: 2px solid rgb(133,135,150,0.5);" />
        <div class="row mt-2">
            <div class="col">
              <p v-if="topic.description!=null && topic.description!=''">{{topic.description}}</p>
              <p v-else class="text-danger">Сэдвийн тайлбар ороогүй байна</p>
            </div>
        </div>
        <div class="row" >
          <div v-if="topic.tags!=null && topic.tags!=undefined && topic.tags.length>0">
            Түлхүүр үгс:
            <span class="badge badge-pill badge-success mr-2" v-for="(tag, ti) in topic.tags">
              {{tag}}
              <!-- <i class="fas fa-times ml-2" style="cursor:pointer" @click="removeTag(tag, ti)"></i> -->
            </span>
          </div>

        </div>
        <div>
          <div v-if='display==0'>
            <table class="table table-condensed table-hover" v-if="topic.details && topic.details.length>0">
                <tbody>
                  <tr v-for="(topicContent, index) in topic.details" v-bind:key="topicContent.id" @click='goContentDetail(topic, topicContent)' style="cursor:pointer">
                    <td style="width:2%">{{topicContent.type}}..{{index+1}}.</td>
                    <td v-if="topicContent.type=='lecture'">{{topicContent.name}} <span class="ml-1 badge badge-warning" style="color:black">{{getType(topicContent.type)}}</span></td>
                    <td v-else-if="topicContent.type=='video'">{{topicContent.name}} <span class="ml-1 badge badge-warning" style="color:black">{{getType(topicContent.type)}}</span></td>
                    <td v-else-if="topicContent.type=='seminar'">{{topicContent.name}} <span class="ml-1 badge badge-warning" style="color:black">{{getType(topicContent.type)}}</span></td>

                    <td v-else-if="topicContent.type=='coursework'">{{topicContent.name}} <span class="ml-1 badge badge-info" style="color:black">{{getType(topicContent.type)}}</span></td>
                    <td v-else-if="topicContent.type=='assignment'">{{topicContent.name}} <span class="ml-1 badge badge-info" style="color:black">{{getType(topicContent.type)}}</span></td>
                    <td v-else-if="topicContent.type=='coursework'">{{topicContent.name}} <span class="ml-1 badge badge-info" style="color:black">{{getType(topicContent.type)}}</span></td>

                    <td v-else-if="topicContent.type=='test'">{{topicContent.name}} <span class="ml-1 badge badge-danger" style="color:black">{{getType(topicContent.type)}}</span></td>
                    <td v-else-if="topicContent.type=='exam'">{{topicContent.name}} <span class="ml-1 badge badge-danger" style="color:black">{{getType(topicContent.type)}}</span></td>

                    <td v-else>{{topicContent.name}} <span class="ml-1 badge badge-warning" style="color:black">{{getType(topicContent.type)}}</span></td>
                  </tr>
                </tbody>
            </table>
            <!-- <div v-else class="text-primary">Одоогоор агуулга нэмээгүй байна.</div> -->
          </div>

          <div class="list-group" v-else>
            <div v-for="(item, index) in topic.details" v-bind:key="item.id"  class="list-group-item list-group-item-action flex-column align-items-start ">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{index+1}}. {{item.name}}</h5>
                <div>
                  <small v-if="item.type!=null && item.type!=undefined">
                    {{item.type}}
                  </small>
                  <small class="ml-2">
                        <i class="fas fa-edit text-danger" @click="_editContent(item,topic)" ></i>
                  </small>
                </div>
              </div>
              <p class="mb-1">{{item.description}}</p>
              <p class="mb-1" v-if="item.duration!=null">Үргэлжлэх хугацаа :{{item.duration}} минут</p>
              <div class="my-3">
                <span class="d-flex">
                  <div v-if="item.announcement==true" style="cursor:pointer" @click="setPropContent(false,topic, item, 'announcement')"><span class="badge badge-success">Зарлал болгосон</span></div>
                  <div v-else @click="setPropContent(true,topic, item, 'announcement')" style="cursor:pointer"><span class="badge badge-danger">Зарлал болгоогүй</span></div>
                  <span class="ml-2 d-flex" v-if="item.announcement==true">
                    <div v-if="item.open==true" style="cursor:pointer" @click="setPropContent(false,topic, item, 'open')"><span class="badge badge-success">Зарлал нээлттэй</span></div>
                    <div v-else @click="setPropContent(true,topic, item, 'open')" style="cursor:pointer"><span class="badge badge-danger">Зарлал хаалттай</span></div>
                  </span>
                </span>
               
                
              </div>
              <p class="mb-1" v-if="item.startDay!=null">Эхлэх: {{item.startDay | formatDate}}</p>
              <p class="mb-1" v-if="item.endDay!=null">Дуусах: {{item.endDay | formatDate}}</p>
              
              <button @click="$router.push({ name: 'DetailQuestions', params: { lessonId: lesson.id, topicId: topic.id, detailId: item.id} })" class="btn btn-info my-3 btn-sm" v-if="item.type!=null && item.type!=undefined && item.type=='exam'">Шалгалтын асуулт бэлдэх</button>
              
              <button @click="$router.push({ name: 'DetailQuestions', params: { lessonId: lesson.id, topicId: topic.id, detailId: item.id} })" class="btn btn-info my-3 btn-sm" v-if="item.type!=null && item.type!=undefined && item.type=='test'">Тестын  асуулт бэлдэх</button>
              <ul>
                <li style="margin-bottom: 18px;"  v-if="item.videoUrl!=null">
                  <p>Хэрэв таны видео зөв xxорсон бол доdddор шууд харагдана.</p>
                  <a v-bind:href="item.videoUrl" target="blank">  {{ item.videoUrl }} </a>
                  <br/>

                  <iframe width="560" height="315" v-if="item.videoUrl!=null && item.videoUrl!='' && item.videoUrl.toLowerCase().indexOf('youtube') != -1" v-bind:src="getYoutubeIframe(item.videoUrl)"  frameborder="0" allowfullscreen></iframe>
                
                </li>
                <li  v-if="item.files!=null && item.files.length>0">
                  <div>
                      <div v-for="(file, index) in item.files" v-bind:key="file.id" v-if="validFile(file)">
                        <a v-bind:href="file.fileUrl" target="_blank"><i class="fas fa-download"></i> {{file.fileName}}</a>
                        <i class="fas fa-trash text-danger ml-2" @click="_deleteTopicFile(topic,item, file, index)"></i>
                      </div>
                  </div>
                </li>
              </ul>
              <input type="file" :ref="'file_' + item.id" @change="uploadFile(topic, item)">
              <div v-if="item.files==null || (item.files!=null && item.files.length==0) " class="my-2 alert alert-info">Та {{item.name}} агуулгын материалыг /ppt, pptx, docx, doc болон pdf файл/ оруулах боломжтой.</div>
              
              <div class="progress" v-if="item.uploading">
                <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.uploadPercent + '%' }" aria-valuemin="0" aria-valuemax="100">{{item.uploadPercent.toFixed()}}%</div>
              </div>

            </div>
           
          </div>
        </div>
      </div>
        </div>
      </div>
      

      <!-- ContentModal -->
      <div class="modal fade" id="contentModal" tabindex="-1" role="dialog" aria-labelledby="contentModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="">
                <div class="">
                  <h5 class="modal-title" >Агуулга нэмэх</h5>
                </div>
                
              </div>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
       
              
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="form-group">
                  <label>Агуулгын нэр: </label>
                  <input v-model.trim="content.name" class="form-control" placeholder="">
                </div>

                <div class="form-group">
                  <label>Агуулгын дэлгэрэнгүй тайлбар: </label>
                  <textarea rows="2" v-model.trim="content.description" class="form-control"  placeholder=""/>
                </div>
                <div class="form-group">
                  <label>Youtube видеоны xичээлийн линк <span class="text-primary">/Xэрэв агуулга нь видео линктэй бол/</span></label>
                  <input v-model.trim="content.videoUrl" class="form-control" placeholder="">
                </div>
                <div class="form-group">
                  <label>IFrame линк оруулаx <span class="text-primary">/Жиш: Google Slides, Microsoft Powerpoint .../</span></label>
                  <textarea rows="2" v-model.trim="content.iframeurl" class="form-control"  placeholder=""/>
                </div>
   
                <div class="form-group">
                  <label for="exampleFormControlSelect1">Агуулгын төрөл: </label>
                  <select class="form-control" v-model="selectedType" >
                    <option v-for="(type) in typess" v-bind:key="type.id" v-bind:value="type.id">{{type.title}}</option>
                  </select>
                </div>
                <div class="row" v-if="selectedType && selectedType=='assignment'">
                  <div class="col">
                    <div class="form-check">
                      <input type="checkbox" v-model="content.graded" class="form-check-input" id="exampleCheck1">
                      <label class="form-check-label font-weight-bold text-danger" for="exampleCheck1">Оноотой эсэх</label>
                    </div>
                  </div>
                  <div class="col" v-if="content && content.graded && content.graded==true">
                    <div class="form-group">
                      <label>Дүгнэх дээд оноо: </label>
                      <input v-model.number="content.totalScore" class="form-control" type="number" placeholder="Дээд оноо">
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="form-check">
                      <input type="checkbox" v-model="advanced" @click="advanced=!advanced" class="form-check-input" id="exampleCheck1">
                      <label class="form-check-label" for="exampleCheck1">Нэмэлт мэдээлэл оруулаx</label>
                    </div>
                </div>  

              <!-- <div class="ml-3">
                    <i class="fas fa-grip-horizontal text-danger" style="font-size:20px; cursor:pointer" title="Дэлгэрэнгүй болгож xараx" v-if="!advanced" @click="advanced=!advanced"></i>
                    <i class="fas fa-grip-lines text-danger" style="font-size:20px; cursor:pointer" title="Xураангуйлан xараx" v-else @click="advanced=!advanced"></i>
              </div> -->

                <div class="form-group"  v-if="advanced==true">
                  <label>Агуулгын товч нэр (Жиш:/VA, VariantB/): </label>
                  <input v-model.trim="content.shortname" class="form-control" placeholder="">
                </div>
                <div class="form-group"  v-if="advanced==true">
                  <label>Видеоны хугацаа/мин/: </label>
                  <input v-model.number="content.duration" class="form-control" type="number" placeholder="">
                </div>
                <div class="row">
                  <div class="col-md-6 col-sm-12 form-group" v-if="advanced==true">
                    <label>Эхлэх: </label>
                    <input v-model="content.startDayStr" class="form-control" placeholder="Агуулга нээгдэх хугацаа" type="date">
                  </div>
                  <div class="col-md-6 col-sm-12 form-group" v-if="advanced==true">
                    <label>Дуусах: </label>
                    <input v-model="content.endDayStr" class="form-control" placeholder="Агуулга дуусах хугацаа" type="date">
                  </div>
                </div>
              
 
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
              <button @click="saveContent(selectedTopic)" type="button" class="btn btn-primary btn-user btn-block">Хадгалах</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'


export default {
    name: "ShareTeacherTopics",

    data() {
        return {
            display:0,
            selectedTopic:null,
            content:{
              'name':null,
              'description':null,
              'videoUrl':null,
              'published':false,
              'startDay':null,
              'endDay':null,
              'code':null,
              'duration':null,
              'shortname':null,
              iframeurl:null
            },
            selectedType:null,
            selectedTopic:null,
            advanced:false

        };
    },

    methods: {
        openSaveContentModal(topic){
            this.selectedTopic=topic;
            $('#contentModal').modal('show');

        },
        saveContent(topic) {
        if(this.content!=null && this.content.name!=null && this.content.name!='' && this.selectedType!=null){
          if(this.content.videoUrl!=null && this.content.videoUrl!='' ){
            if (this.content.videoUrl.toLowerCase().indexOf("youtube") == -1) {
              alert("Та заавал youtube бичлэг оруулна уу");
              return;
            }
          }
          this.content.typeRef=fb.db.collection("ContentTypes").doc(this.selectedType);
          this.content.type=this.selectedType;
        
          if(this.lesson!=null && topic!=null && topic.id!=null && this.content!=null && this.content!=undefined){

              if(this.content.startDayStr!=null && this.content.startDayStr!=''){
                this.content.startDay=new Date(this.content.startDayStr);
              }

              if(this.content.endDayStr!=null && this.content.endDayStr!=''){
                this.content.endDay=new Date(this.content.endDayStr);
              }
                  
              if(this.selectedType!=null && this.selectedType=="exam"){
                this.content.roundCount=1;
              }
              else if(this.selectedType!=null && this.selectedType=="test"){
                this.content.roundCount=10;
              }

              if(this.content.id!=undefined && this.content.id!=null && this.content.id!='' && this.content.id!='new'){
                this.content.modifiedAt=new Date();
                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("topics").doc(topic.id).collection("details").doc(this.content.id).update(this.content)
              }
              else{
                this.content.createdAt=new Date();
                this.content.code=new Date().getTime().toString();
                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("topics").doc(topic.id).collection("details").doc().set(this.content)
                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("topics").doc(topic.id).update({
                  'numberOfContent':fb.firestore.FieldValue.increment(1)
                });

                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).update({
                  'numberOfContent':fb.firestore.FieldValue.increment(1)
                });
                
                if(this.content.videoUrl!=null && this.content.videoUrl!=''){
                  fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).update({
                    'numberOfVideos':fb.firestore.FieldValue.increment(1)
                  });
                }

              }
              

              this.selectedType=null;
              this.selectedTopic=null;
              this.content={
                'name':null,
                'description':null,
                'videoUrl':null,
                'published':false,
                'startDay':null,
                'endDay':null,
                'code':null,
                'duration':null,
                'shortname':null,
                iframeurl:null
              }
    
          }
          $('#contentModal').modal('hide');
        }
        else{
          alert("Та талбаруудыг гүйцэд бөглөнө үү");
        }
      },

      _editContent(content, topic){
          this.selectedTopic=topic;
            this.content= Object.assign({}, content);
            this.selectedType=content.type;
            $('#contentModal').modal('toggle');
      },
      _deleteContent(topic, content, index){
 
            var result = confirm("Та "+content.name+" агуулгыг устгах уу?");
            if (result) {
                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("topics").doc(topic.id).collection("details").doc(content.id).delete();
            }
      },
      _deleteTopic(topic, index){
            var result = confirm("Та "+topic.name+" сэдвийг устгах уу?");
            if (result) {
                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("topics").doc(topic.id).delete();
            }

      },
      _deleteTopicFile(topic,content, file, index){
          var result = confirm("Та "+file.fileName+" файлыг устгах уу?");
            if (result) {
              var fileName=file.fileName;
              var fileRef = fb.storageRef.child(fileName);
              fileRef.delete().then(() =>{
                content.files.splice(index, 1)
                fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("topics/"+topic.id+"/details").doc(content.id).update({
                    files: content.files
                  }
                )
              }).catch(function(error) {

              });
                
            }
      },
      goContentDetail(topic, content) {

          if(topic!=null && content!=null ){
            if(content.type=="exam" || content.type=="test")
              this.$router.push({ name: 'IQuestions', params: {schoolId: this.schoolId, lessonId: this.lessonId, topicId: topic.id, detailId: content.id} });
            else {
              console.log('aaa');
              this.$router.push({ name: "IContentDetail", params: {schoolId: this.schoolId, lessonId: this.lessonId, topicId:topic.id, contentId: content.id, showContainer:true} });
            
              // this.$router.push({ name: "IVideoWatcher", params: {schoolId: this.schoolId, lessonId: this.lessonId, topicId:topic.id, contentId: content.id, showContainer:true} });
            }
              //this.$router.push({ name: "IVideoFrame", params: {schoolId: this.schoolId, lessonId: this.lessonId, topicId:topic.id, contentId: content.id, showContainer:true} });
              //
          }
      },
      getType(type){
        if(type=="test")
          return "Тест давтлага";
        else if(type=="video")
          return "Хичээл";
        else if(type=="lecture")
          return "Хичээл";
        else if(type=="seminar")
          return "Семинар";
        else if(type=="exam")
          return "Шалгалт";
        else if(type=="homework")
          return "Гэрийн даалгавар";
        else if(type=="coursework")
          return "Бие даалт";
        else if(type=="assignment")
          return "Даалгавар";
        
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        topics: { 
            required: true,
        },
        // removeAllowedShareLink: {
        //   required:true
        // },
        lesson:{
            required:true
        },
        typess:{
            required:false
        },
        removeAllowedShareLink:{
            required:false
        },
        schoolId:{
            required:true
        },
        lessonId:{
            required:true
        },
        _editTopic:{
            required:true
        },
  
    },
    created() {
 
      //console.log('xx',this.removeAllowedShareLink);
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

<style>
  .hover-card :hover{
    background-color:rgba(11, 13, 15, 0.03);
    opacity: 1;
  }
  .myicon{
    color:#E3E5EA!important;
  }
  .myicon:hover{
    color:black!important
  }

</style>
